import React from 'react'
import styled from 'styled-components'
import {CheckBox as GrommetCheckBox} from 'grommet/components/CheckBox'
import {Grommet} from 'grommet/components/Grommet'
import {grommet} from 'grommet/themes'
import {deepMerge} from 'grommet/utils'

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #f3f5fb;
  border-radius: 6px;
  height: 46px;
  font-size: 14px;
  font-weight: 600;
  box-sizing: border-box;
  padding: 0 10px 0 10px;
`

const customCheckBoxTheme = {
  checkBox: {
    border: {
      color: {
        light: '#a4a9b7'
      },
      radius: '4px'
    },
    color: '#3395fe',

    check: {
      extend: ({checked}) => {
        if (checked) {
          return `background-color: #3395fe;border:1px solid #3395fe;`
        }
      }
    },
    hover: {
      border: {
        color: undefined
      }
    },
    icon: {
      size: '18px',
      extend: 'stroke: white;'
    },
    gap: 'xsmall'
  }
}

const CheckBox = ({label, checked, index, onChange}) => {
  const onCheckChange = ({index, checked}) => {
    onChange(index, checked)
  }

  return (
    <Grommet theme={deepMerge(grommet, customCheckBoxTheme)}>
      <Container>
        <GrommetCheckBox
          label={label}
          checked={checked}
          onChange={evt => onCheckChange({index, checked: evt.target.checked})}
        />
      </Container>
    </Grommet>
  )
}

export default CheckBox
